// TODO(KLRP-419): placeholder enum values — align the exact strings with the BE
// API contract once defined; the known license types are fixed (fundamental,
// gmail only, sso only)
export enum LicenseType {
  Fundamental = 'FUNDAMENTAL',
  GmailOnly = 'GMAIL_ONLY',
  SsoOnly = 'SSO_ONLY',
}

export const LICENSE_TYPE_LABEL: Record<LicenseType, string> = {
  [LicenseType.Fundamental]: 'Fundamental',
  [LicenseType.GmailOnly]: 'Gmail Only',
  [LicenseType.SsoOnly]: 'SSO Only',
}

// TODO @archelia (KLRP-419): placeholder status values per Figma — align the exact
// strings with the BE API contract once defined
export enum LicenseUpgradeSubmissionStatus {
  BelumDisetujui = 'BELUM_DISETUJUI',
  Disetujui = 'DISETUJUI',
  Ditolak = 'DITOLAK',
}

// TODO @archelia (KLRP-419): field names mirror the UI template — align with the BE API
// contract once defined (list + detail payloads must include submitted_by /
// "Diajukan Oleh" and the lampiran document name + URL)
// per-account execution outcome — BE confirmed (2026-07-17) that individual
// accounts can fail after the pengajuan is APPROVED
export enum LicenseUpgradeAccountStatus {
  Pending = 'PENDING',
  Upgraded = 'UPGRADED',
  Failed = 'FAILED',
}

// one account inside a submission — mirrors what BE snapshots per account at
// submit time (full_name, kelas, current license) plus the upgrade outcome
export interface LicenseUpgradeSubmissionAccount {
  pd_id: string
  full_name: string
  email: string
  kelas: string
  current_license_type: LicenseType
  upgrade_status: LicenseUpgradeAccountStatus
  new_license_type: LicenseType | null
  upgraded_at: string | null
  failure_reason: string | null
}

export interface LicenseUpgradeSubmission {
  id: number | string
  created_at: string
  npsn: string
  total_accounts: number
  reason: string
  status: LicenseUpgradeSubmissionStatus
  submitted_by: string
  document_name?: string
  document_url?: string
}
